import * as React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from '../Modules.State';
import ModulesAction from '../Modules.Action';
import withRouter from 'src/routes/withRouter';
import AppCard from 'src/display/components/AppCard';
import { Checkbox } from 'antd';
import { mediaUrl as mediaUrlHandle } from 'kts-platform-frame/entry/configUtils';
import IcoCaveat from './img.caveat';
const mediaUrl = mediaUrlHandle();

const css = require('./index.scss');

/** Redux接口 */
interface IReduxStatePart {
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {
}

/** 绑定全局数据 */
@withRouter
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
}))
export default class Head extends UIBasic<IProps, ModulesState> {
    constructor(props: IProps) {
        super(props, ModulesAction);
    }
    render() {
        return (
            <div className={css.carouselbox}  ref={dom => this.modulesState.carouselboxContent = dom}>
                {
                    this.modulesState.appList && this.modulesState.appList.filter(item => !item.isActivated).length > 0 ?
                    <div>
                            {
                                this.modulesState.appList.map((value, index) => {
                                    if (!!value.isActivated) {
                                        return null;
                                    }
                                    return (
                                        <span key={`checkbox${index}`}>
                                            <Checkbox
                                                onChange={(e) => { ModulesAction.appCheckedListHandle(e, value); }}
                                                key={value.appId}
                                                checked={this.modulesState.checkedAppList.has(value.appId)}
                                                className={css.appCardCheck}
                                            >
                                                <AppCard
                                                    key={index}
                                                    className={css.appItem}
                                                    title={value.appName}
                                                    subject={value.appIntroduction}
                                                    icon={value.appIcon ? `${mediaUrl}${value.appIcon}` : null}
                                                    isShowStatus={true}
                                                    status={!!value.isActivated}
                                                    secondName={value.categoryName}
                                                // onClick={() => ModulesAction.openApp(value)}
                                                // buttonGroup={this.groupBtns(value)}
                                                />
                                            </Checkbox>
                                        </span>
                                    );
                                })
                            }
                        </div> :
                        (
                            <div className={css.noData} >
                                <p><i dangerouslySetInnerHTML={{ __html: IcoCaveat }} /></p>
                                <p>暂无应用</p>
                            </div>
                        )
                }

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/display/platform/AppStore/AppManage/AppBatchActivated/UI.Components/UI.List.tsx